import { EvaluationEntry } from '../MultipleEvaluations';
import { DxImageWithPointsAndConditions, ImageDxPointValue, ImageDxPointValues } from './imageDxTypes';

// getFormattedPointValues returns a formatted version of the point values for the given point names, evaluations, and
// the initial evaluation value (i.e. the default value for each pain selector; 0 for "-").
export const getFormattedPointValues = (
  pointNames: string[],
  evaluations: EvaluationEntry[],
  initialEvaluationValue: number,
  currentPointValues: ImageDxPointValues
): ImageDxPointValues => {
  const formattedValues: ImageDxPointValues = {};
  // Initialize the formatted values for each point name with the initial evaluation value
  pointNames.forEach((pointName) => {
    const formattedPointValue: ImageDxPointValue = {
      evaluations: {},
      conditions: []
    };
    evaluations.forEach((evaluation) => {
      if (formattedPointValue?.evaluations) {
        formattedPointValue.evaluations[evaluation.value] = initialEvaluationValue;
      }
    });
    formattedValues[pointName] = formattedPointValue;
  });

  // Set current values if they exist
  if (currentPointValues) {
    Object.keys(currentPointValues).forEach((pointName) => {
      if (formattedValues[pointName]) {
        evaluations.forEach((evaluation) => {
          if (formattedValues?.[pointName]?.evaluations) {
            formattedValues[pointName].evaluations[evaluation.value] =
              currentPointValues[pointName]?.evaluations?.[evaluation.value] || initialEvaluationValue;
          }
        });
        formattedValues[pointName].conditions = currentPointValues[pointName]?.conditions || [];
      }
    });
  }

  return formattedValues;
};

// getPointNames extracts unique point names from the diagnosis images.  There may be multiple images with the same
// (e.g. the back might be on the left and right images)
export const getPointNames = (diagnosisImages: DxImageWithPointsAndConditions[]): string[] =>
  Array.from(new Set(diagnosisImages.flatMap((di) => (di.points || []).map((point) => point.name))));
